export default __webpack_public_path__ + "media/images/document-dossier-g1525-orange-papier-icone-7920-96-9b1b9713119495e21ad5494867edfada.png";